import { Station } from '@app/core/types/stations';
import { getAuditListingDefaultDate } from '@app/modules/audit/modules/station-audit/helpers/default-listing-date-range';
import { auditMentionsAuditMentionsDateSchedulesList } from '@mi-front/api-v2';
import { DateStr, GetPntScheduleDto, Paginated } from '@mi-front/core';
import { ReportView } from '../../../../../../../../core/reports/components/ReportView';
import { ReportType } from '../../../../../../../../core/reports/types';
import { SchedulesListMentionsIndexForm } from './SchedulesListMentionsIndexForm';
import { SchedulesListMentionsIndexResult } from './SchedulesListMentionsIndexResult';

type Props = {
  station: Station;
};

export type SchedulesMentionsIndexListing = ReportType<
  { date: DateStr },
  Paginated<GetPntScheduleDto>
>;

/**
 * Mentions date-schedules index for a station/day via api-v2.
 */
export function MentionsIndexView(p: Props) {
  return (
    <ReportView<SchedulesMentionsIndexListing>
      defaultValues={{
        date: getAuditListingDefaultDate(),
      }}
      runOnLoad
      download={false}
      reportFn={async (values) => {
        return auditMentionsAuditMentionsDateSchedulesList({
          station: p.station.id,
          date: values.date,
        }) as Promise<Paginated<GetPntScheduleDto>>;
      }}
      Form={SchedulesListMentionsIndexForm}
      Result={SchedulesListMentionsIndexResult}
    />
  );
}
